import React, {useEffect, useState} from 'react';
import './style.css';
import {ArrowRightOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import dayjs from 'dayjs';
import {
  EventRegistrationStatus,
  EventRegistrationType,
  eventStatusRegistrationClosed,
  formatTimeZoneString,
  maxTagPlaceholder,
  tagRender,
} from '../../../../Util/commonUtility';
import StatusUpdateModal from '../../CommonModal';
import {useDispatch, useSelector} from 'react-redux';
import {Button} from 'antd';
import {editRefundStatusById} from './../../../../Store/Actions/events';
import {cancelEventRegistrationsByEventIds} from './../../../../Store/Actions/eventRegister';
import {FETCH_ERROR} from '../../../../Constant/ActionTypes';
import EventDetailsModal, {
  getTransactionIdString,
  isRefundableRegistration,
  isCancellableZeroPriceRegistration,
} from './EventRegistrationModal';
import {getAllChapters} from '../../../../Store/Actions';
import {getAllMyEvents} from '../../../../Store/Actions/events';
import ReceiptComponent from '../../receiptComponent';
import useLocalization from '../../../../Localization';
import moment from 'moment';

const MyEventCard = ({
  eventType,
  paid,
  registration_status,
  eventName,
  eventLocalChapterId,
  date,
  chapter,
  attendees,
  isExpand,
  eventRegistrationType,
  receiptData,
  usedForMyEvents = false,
  usedForMyEventsCart = false,
  sponsors,
  eventId,
  status,
  eventStartDate,
  allRegistrationWaitingList,
  dateObject,
  onMyEventsRefresh,
}) => {
  let dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [attendeeIds, setAttendeeIds] = useState([]);
  const [refundToAccount, setRefundToAccount] = useState(false);
  const [isEventDetailsOpen, setIsEventDetailsOpen] = useState(false);
  const [showUpdateStatus, setShowUpdateStatus] = useState([]);
  const [isCancelModalVisible, setIsCancelModalVisible] = useState(false);
  const [cancelAttendeeIds, setCancelAttendeeIds] = useState([]);
  const [cancelShowUpdateStatus, setCancelShowUpdateStatus] = useState([]);
  const [eventOptionId, setEventOptionId] = useState();
  const [refundScopeAttendees, setRefundScopeAttendees] = useState(null);
  const [cancelScopeAttendees, setCancelScopeAttendees] = useState(null);
  const [activeTabAttendees, setActiveTabAttendees] = useState([]);
  const {ApplicationString} = useLocalization();

  const allChapters = useSelector((state) => state.chapters.allChapters);
  const eventLocalChapterData = allChapters?.data?.chapters?.find(
    (obj) => obj.id === eventLocalChapterId,
  );
  useEffect(() => {
    if (!allChapters) {
      dispatch(getAllChapters());
    }
  }, [allChapters]);
  const Navigate = useNavigate();
  const effectiveEventStartDate = eventStartDate || dateObject?.event_start_date;
  const isWaitingListRegistration =
    eventRegistrationType === EventRegistrationType.waitingList;
  const registrationsForActions = isWaitingListRegistration
    ? attendees
    : eventRegistrationType === 'sponsorship'
      ? sponsors
      : attendees;
  const filteredAttendees = isWaitingListRegistration
    ? attendees
    : registrationsForActions?.filter(isRefundableRegistration);
  const zeroPriceAttendees = isWaitingListRegistration
    ? []
    : registrationsForActions?.filter(isCancellableZeroPriceRegistration);
  const createAttendeeSelectionOptions = (attendeeList) =>
    attendeeList?.map((attendee) => {
      const firstName = attendee?.attendee_first_name || '';
      const lastName = attendee?.attendee_last_name || '';
      const fullName = `${firstName} ${lastName}`.trim();
      const email = attendee?.attendee_email?.trim();
      return {
        value: attendee?.id,
        label: `${fullName}${email ? ` (${email})` : ''}`,
      };
    });

  const SelectOptionForAttendees = createAttendeeSelectionOptions(
    (refundScopeAttendees || filteredAttendees)?.filter(
      isRefundableRegistration,
    ),
  );
  const CancelSelectOptionForAttendees = createAttendeeSelectionOptions(
    (cancelScopeAttendees || zeroPriceAttendees)?.filter(
      isCancellableZeroPriceRegistration,
    ),
  );
  const handleChange = (value) => {
    setShowUpdateStatus(value);
    setAttendeeIds(value);
  };
  const handleCancelChange = (value) => {
    setCancelShowUpdateStatus(value);
    setCancelAttendeeIds(value);
  };
  const handleRefundVisible = () => {
    setAttendeeIds([]);
    setShowUpdateStatus([]);
    setRefundScopeAttendees(activeTabAttendees);
    setIsModalVisible(true);
  };
  const hideModal = () => {
    setIsModalVisible(false);
    setRefundScopeAttendees(null);
  };
  const handleCancelVisible = () => {
    setCancelAttendeeIds([]);
    setCancelShowUpdateStatus([]);
    setCancelScopeAttendees(activeTabAttendees);
    setIsCancelModalVisible(true);
  };
  const hideCancelModal = () => {
    setIsCancelModalVisible(false);
    setCancelScopeAttendees(null);
  };

  const handleUpdateStatus = () => {
    if (!attendeeIds || attendeeIds?.length <= 0) {
      dispatch({
        type: FETCH_ERROR,
        payload: ApplicationString['myEventCard.pleaseSelectAttendee'],
      });
      return;
    }
    const Data = {
      eventRegistrationIds: attendeeIds,
      status: 2,
    };
    dispatch(editRefundStatusById(Data)).then(() => {
      if (onMyEventsRefresh) {
        onMyEventsRefresh();
      } else {
        dispatch(getAllMyEvents());
      }
    });
    setIsModalVisible(false);
    setRefundScopeAttendees(null);
  };
  const handleCancelRegistration = () => {
    if (!cancelAttendeeIds || cancelAttendeeIds?.length <= 0) {
      dispatch({
        type: FETCH_ERROR,
        payload: ApplicationString['myEventCard.pleaseSelectAttendee'],
      });
      return;
    }
    const Data = {
      eventRegistrationIds: cancelAttendeeIds,
    };
    dispatch(cancelEventRegistrationsByEventIds(Data)).then(() => {
      if (onMyEventsRefresh) {
        onMyEventsRefresh();
      } else {
        dispatch(getAllMyEvents());
      }
    });
    setIsCancelModalVisible(false);
    setCancelScopeAttendees(null);
  };

  const handleCompletePayment = (e) => {
    e.preventDefault();
    if (parseInt(status) === eventStatusRegistrationClosed) {
      dispatch({
        type: FETCH_ERROR,
        payload: ApplicationString['myEventCard.registrationClosed'],
      });
    }
    if (eventRegistrationType === 'sponsorship') {
      Navigate(`/eventSponsor/${eventId}/${eventOptionId}`);
    } else {
      Navigate(`/addAttendees/${eventId}`);
    }
  };

  const handleEditRegistrationForToBePaid = (e) => {
    e.preventDefault();
    if (eventRegistrationType === 'sponsorship') {
      // Reps added to an already-paid sponsorship (no sponsor row in the cart): pay for them directly.
      // This stays open after event registration closes, until one week before the event.
      const toBePaidAddedReps = cartRegistrations?.filter(
        (r) =>
          r?.status === EventRegistrationStatus.TO_BE_PAID &&
          r?.is_reps &&
          r?.parent_sponsor_id,
      );
      const hasToBePaidSponsor = cartRegistrations?.some(
        (r) =>
          r?.status === EventRegistrationStatus.TO_BE_PAID && r?.is_sponsor,
      );
      if (!hasToBePaidSponsor && toBePaidAddedReps?.length > 0) {
        const parentIds = [
          ...new Set(
            toBePaidAddedReps
              .map((rep) => rep?.parent_sponsor_id)
              .filter(Boolean),
          ),
        ];
        if (parentIds.length > 1) {
          dispatch({
            type: FETCH_ERROR,
            payload: ApplicationString['sponsorshipReps.payEachSponsorship'],
          });
          return;
        }
        Navigate(`/addVendorReps/${eventId}/${parentIds[0]}`);
        return;
      }
    }
    if (parseInt(status) === eventStatusRegistrationClosed) {
      dispatch({
        type: FETCH_ERROR,
        payload: ApplicationString['myEventCard.registrationClosed'],
      });
    }
    if (eventRegistrationType === 'sponsorship') {
      if (hasPaymentProcessingInCart) {
        const transactionId = cartRegistrations?.find(
          (r) => r?.status === EventRegistrationStatus.PAYMENT_PROCESSING,
        )?.transaction_id;
        const tid = getTransactionIdString(transactionId);
        Navigate(`/eventSponsorCart/${eventId}/${eventOptionId}/${tid}`);
      } else {
        Navigate(`/eventSponsor/${eventId}/${eventOptionId}`);
      }
    } else {
      // Payment processing: use transaction id in URL; to-be-paid: add attendees (coupon + pay)
      const transactionId =
        hasPaymentProcessingInCart &&
        cartRegistrations?.find(
          (r) => r?.status === EventRegistrationStatus.PAYMENT_PROCESSING,
        )?.transaction_id;
      const tid = getTransactionIdString(transactionId);
      Navigate(
        tid ? `/attendeesCart/${eventId}/${tid}` : `/addAttendees/${eventId}`,
      );
    }
  };

  const handlePayInCart = (e) => {
    e.preventDefault();
    Navigate('/myCart');
  };

  const handleEventDetailCancel = () => {
    setIsEventDetailsOpen(false);
  };

  const renderButtons = () => {
    const isEventExpired = effectiveEventStartDate
      ? dayjs(effectiveEventStartDate).isBefore(dayjs(), 'minute')
      : false;
    const tabAttendees = Array.isArray(activeTabAttendees)
      ? activeTabAttendees
      : [];
    const hasFilteredAttendees = tabAttendees.some(isRefundableRegistration);
    const hasZeroPriceAttendees = tabAttendees.some(
      isCancellableZeroPriceRegistration,
    );
    const isPaymentStatusPaid = paid;

    if (isEventExpired) {
      return [];
    }

    const buttons = [];

    if (
      hasFilteredAttendees &&
      isPaymentStatusPaid &&
      eventRegistrationType !== EventRegistrationType.waitingList
    ) {
      buttons.push(
        <Button
          type='primary'
          className='common-button-refund'
          key='ask-for-refund'
          onClick={handleRefundVisible}>
          {ApplicationString['myEventCard.askForRefund']}
        </Button>,
      );
    }
    if (
      hasZeroPriceAttendees &&
      isPaymentStatusPaid &&
      eventRegistrationType !== EventRegistrationType.waitingList
    ) {
      buttons.push(
        <Button
          type='primary'
          className='common-button-refund'
          key='cancel-registration'
          onClick={handleCancelVisible}>
          {ApplicationString['myEventCard.cancelRegistration']}
        </Button>,
      );
    }
    if (
      !paid &&
      eventRegistrationType !== EventRegistrationType.waitingList
    ) {
      if (usedForMyEventsCart && hasToBePaidInCart) {
        buttons.push(
          <Button
            type='primary'
            className='common-button-refund'
            key='edit-registration'
            onClick={handleEditRegistrationForToBePaid}>
            {ApplicationString['myEventCard.editRegistration']}
          </Button>,
        );
      } else if (!usedForMyEventsCart) {
        buttons.push(
          <Button
            type='primary'
            className='common-button-refund'
            key='pay-in-cart'
            onClick={handlePayInCart}>
            {ApplicationString['myEventCard.payInCart']}
          </Button>,
        );
      }
    }
    return buttons;
  };

  const getSponsorshipOptionIds = (sponsors) => {
    return sponsors
      ?.filter(
        (sponsor) =>
          (sponsor?.status === EventRegistrationStatus.TO_BE_PAID ||
            sponsor?.status === EventRegistrationStatus.PAYMENT_PROCESSING) &&
          sponsor?.is_sponsor === true,
      )
      .map((sponsor) => {
        const sponsorship = sponsor?.event_registration_options?.sponsorship;
        return sponsorship?.event_sponsorship_perk?.event_option_id || null;
      })
      .filter((eventOptionId) => eventOptionId !== null);
  };

  const cartRegistrations =
    eventRegistrationType === EventRegistrationType.sponsorship
      ? sponsors || []
      : attendees || [];
  const hasToBePaidInCart = cartRegistrations?.some(
    (r) => r?.status === EventRegistrationStatus.TO_BE_PAID,
  );
  const hasPaymentProcessingInCart = cartRegistrations?.some(
    (r) => r?.status === EventRegistrationStatus.PAYMENT_PROCESSING,
  );
  const showCompletePaymentInCart =
    usedForMyEventsCart && !paid && hasToBePaidInCart;
  const showPaymentProcessingBadgeInCart =
    usedForMyEventsCart && !paid && hasPaymentProcessingInCart;

  useEffect(() => {
    if (sponsors) {
      const sponsorshipOptionIds = getSponsorshipOptionIds(sponsors);
      setEventOptionId(sponsorshipOptionIds);
    }
  }, [sponsors]);

  useEffect(() => {
    setShowUpdateStatus([]);
  }, [eventRegistrationType]);
  const formattedStartDate = moment(dateObject?.event_start_date)
    .utcOffset(0)
    ?.format('DD MMM YYYY');
  const formattedEndDate = moment(dateObject?.event_end_date)
    .utcOffset(0)
    ?.format('DD MMM YYYY');

  return (
    <React.Fragment>
      {/* <div className='event-wrapper-container'> */}
      <StatusUpdateModal
        showUpdateStatus={showUpdateStatus}
        isModalCentred={'centered'}
        refundBool={false}
        isColorSchemeUser={true}
        statusHeading={
          eventRegistrationType === EventRegistrationType.sponsorship
            ? `${ApplicationString['myEventCard.selectAttendeeForRefund']} ${ApplicationString['sponsorshipReps.cancelCascadeNote']}`
            : ApplicationString['myEventCard.selectAttendeeForRefund']
        }
        visible={isModalVisible}
        onCancel={hideModal}
        submitText={ApplicationString['myEventCard.refund']}
        mode={'multiple'}
        maxTagCount={'responsive'}
        maxTagPlaceholder={maxTagPlaceholder}
        tagRender={tagRender}
        handleChange={handleChange}
        handleUpdateJobStatus={handleUpdateStatus}
        selectionOptions={SelectOptionForAttendees}
        setRefundToAccount={setRefundToAccount}
        usedForMyEvents={true}
        width={800}
      />
      <StatusUpdateModal
        showUpdateStatus={cancelShowUpdateStatus}
        isModalCentred={'centered'}
        refundBool={false}
        isColorSchemeUser={true}
        statusHeading={
          ApplicationString['myEventCard.selectAttendeeForCancellation']
        }
        modalTitle={ApplicationString['myEventCard.cancelRegistration']}
        visible={isCancelModalVisible}
        onCancel={hideCancelModal}
        submitText={ApplicationString['myEventCard.cancelRegistration']}
        mode={'multiple'}
        maxTagCount={'responsive'}
        maxTagPlaceholder={maxTagPlaceholder}
        tagRender={tagRender}
        handleChange={handleCancelChange}
        handleUpdateJobStatus={handleCancelRegistration}
        selectionOptions={CancelSelectOptionForAttendees}
        usedForMyEvents={true}
        showCancellationPolicy={false}
        width={800}
      />

      <div className='common-events-listing-card-container'>
        <div className='common-events-listing-card'>
          <div className='common-events-listing-wrapper'>
            <div className='common-events-listing-card-content-wrapper'>
              <div className='cardLeftGroup'>
                <div className='timeLocationDetails'>
                  <div className='locationDateDetails'>
                    <span className='locationText'>{chapter}</span>
                    <div className='extraDetails-desktop'>
                      <span>{eventType}</span>
                    </div>
                    <span className='date-text-myevents'>
                      {formattedStartDate === formattedEndDate
                        ? formattedStartDate
                        : `${formattedStartDate}
                      to ${formattedEndDate}`}
                    </span>
                  </div>
                </div>
                <div className='details-for-mobile'>
                  <div className='extraDetails-mobile'>
                    <span>{eventType}</span>
                  </div>
                </div>
                <div className='common-event-card-title-description-container'>
                  <div
                    className='upcoming-event-card-title hyperlink'
                    onClick={(e) => {
                      e.stopPropagation();
                      Navigate(`/eventDetails/${eventId}`);
                    }}>
                    {eventName}
                  </div>
                </div>
              </div>
              {eventRegistrationType !== EventRegistrationType.waitingList && (
                <div
                  className={`cardRightGroup borderLeft borderLeftNone ${
                    usedForMyEvents && 'usedForMyEvents'
                  }`}>
                  <div className='common-events-listing-card-buttons-container'>
                    {!paid &&
                      usedForMyEventsCart &&
                      showPaymentProcessingBadgeInCart && (
                        <div className='my-event-card-payment-processing-badge'>
                          <span className='my-event-card-payment-processing-badge-dot' />
                          {
                            ApplicationString[
                              'userEventDetailsModal.paymentProcessing'
                            ]
                          }
                        </div>
                      )}
                    {!paid &&
                      (showCompletePaymentInCart ||
                        (!usedForMyEventsCart && usedForMyEvents)) && (
                        <div className='common-events-listing-card-download-button-container '>
                          <button
                            className='download-button myevents-complete-payment-btn-container'
                            id={`myProfileMyEvents-complete-payment-button`}
                            onClick={
                              usedForMyEventsCart
                                ? handleEditRegistrationForToBePaid
                                : handlePayInCart
                            }>
                            <div className='docs'>
                              {usedForMyEventsCart
                                ? ApplicationString[
                                    'myEventCard.completePayment'
                                  ]
                                : ApplicationString[
                                    'myEventCard.payInCart'
                                  ]}{' '}
                              <ArrowRightOutlined />
                            </div>
                          </button>
                        </div>
                      )}
                    {paid && (
                      <div className='common-events-listing-card-download-button-container'>
                        <ReceiptComponent
                          eventRegistrationType={eventRegistrationType}
                          eventData={receiptData}
                          allowDownload={true}
                          eventLocalChapterData={eventLocalChapterData}
                        />
                      </div>
                    )}
                    {renderButtons()?.length > 0 && (
                      <div className='common-events-listing-card-refund-button-container'>
                        {renderButtons()}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <EventDetailsModal
              paidEvent={paid}
              eventOptionId={eventOptionId}
              eventRegistrationType={eventRegistrationType}
              eventName={eventName}
              attendees={attendees}
              sponsors={sponsors}
              filteredAttendees={filteredAttendees}
              isOpen={isEventDetailsOpen}
              paymentStatus={registration_status}
              handleRefund={handleRefundVisible}
              onActiveTabAttendeesChange={setActiveTabAttendees}
              onCancel={handleEventDetailCancel}
              eventStartDate={effectiveEventStartDate}
              eventId={eventId}
              allRegistrationWaitingList={allRegistrationWaitingList}
              eventLocalChapterData={eventLocalChapterData}
              event={receiptData}
              onRefresh={onMyEventsRefresh}
            />

            {/* <div className='common-events-listing-card-status-container'>
              <div className='common-events-listing-card-status'>
                <img
                  src={getColorStatus(registration_status).svg}
                  alt='status-icon'
                  className='myEvents-listing-card-statusImg'
                />
                <span
                  className={getColorStatus(registration_status)?.className}>
                  {registration_status?.length
                    ? getColorStatus(
                        registration_status,
                      )?.nameText.toUpperCase()
                    : 'PENDING'}
                </span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MyEventCard;
